<template>
  <v-container class="pt-6">
    <v-card class="pa-6" outlined style="max-width: 800px; margin: auto;">
      <!-- Header -->
      <div class="d-flex justify-space-between align-center mb-6">
        <div>
          <div style="font-size: 20px; font-family: 'montserrat-bold';">Factura #{{ factura.id }}</div>
          <div style="font-size: 14px; color: #555;">Cliente: {{ factura.cliente }}</div>
          <v-chip class="mt-2" :color="estadoColor" dark small label>
            {{ etiquetaEstado }}
          </v-chip>
        </div>
        <div>
          <div style="font-size: 14px; color: #777;">Fecha de carga</div>
          <div style="font-size: 15px;">{{ factura.fechaCarga }}</div>
        </div>
      </div>

      <!-- Montos -->
      <v-divider></v-divider>
      <v-row class="my-4">
        <v-col cols="6">
          <div class="mb-2"><strong>Monto original:</strong></div>
          <div>${{ formatMoney(factura.montoOriginal) }} USD</div>
        </v-col>
        <v-col cols="6">
          <div class="mb-2"><strong>Monto adelantado:</strong></div>
          <div>${{ formatMoney(factura.montoAdelantado) }} USD</div>
        </v-col>
        <v-col cols="6">
          <div class="mb-2"><strong>Monto final pagado por el pagador:</strong></div>
          <div>${{ formatMoney(factura.montoFinal) }} USD</div>
        </v-col>
        <v-col cols="6">
          <div class="mb-2"><strong>Diferencia:</strong></div>
          <div :class="factura.deudaPendiente > 0 ? 'red--text' : 'green--text'">
            ${{ formatMoney(factura.diferencia) }} USD
          </div>
        </v-col>
      </v-row>

      <!-- Deuda -->
      <v-divider></v-divider>
      <v-row class="mt-4">
        <v-col cols="12">
          <div class="mb-2"><strong>Deuda pendiente:</strong></div>
          <div v-if="factura.deudaPendiente > 0">
            El cliente tiene una deuda pendiente de:
            <strong class="red--text">${{ formatMoney(factura.deudaPendiente) }} USD</strong>
          </div>
          <div v-else class="green--text">
            No hay deuda pendiente en esta factura.
          </div>
        </v-col>
      </v-row>

      <!-- Fechas adicionales -->
      <v-divider class="my-4"></v-divider>
      <v-row>
        <v-col cols="6">
          <div><strong>Fecha de adelanto:</strong></div>
          <div>{{ factura.fechaAdelanto }}</div>
        </v-col>
        <v-col cols="6">
          <div><strong>Fecha de liquidación:</strong></div>
          <div>{{ factura.fechaLiquidacion }}</div>
        </v-col>
      </v-row>

      <!-- Acciones -->
      <v-divider class="my-4"></v-divider>
      <v-row>
        <v-col cols="12" v-if="factura.estado === 'CARGADA'">
          <v-btn color="primary" @click="dialogAprobar = true">Aprobar factura</v-btn>
        </v-col>

        <v-col cols="12" v-if="factura.estado === 'APROBADA'">
          <v-btn color="black" class="white--text" @click="dialogAdelantar = true">Adelantar monto</v-btn>
        </v-col>

        <v-col cols="12" v-if="factura.estado === 'MONTO_CONFIRMADO'">
          <v-btn color="success" @click="dialogLiquidar = true">Liquidar factura</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- DIALOG: Aprobar -->
    <v-dialog v-model="dialogAprobar" max-width="500px">
      <v-card class="pa-6" style="border-radius: 20px;">
        <div class="text-h6 font-weight-bold mb-4">¿Deseas aprobar esta factura?</div>
        <v-btn block color="black" class="white--text" @click="aprobarFactura">Aprobar</v-btn>
      </v-card>
    </v-dialog>

    <!-- DIALOG: Adelantar -->
    <v-dialog v-model="dialogAdelantar" max-width="500px">
      <v-card class="pa-6" style="border-radius: 20px;">
        <div class="text-h6 font-weight-bold mb-4">Monto a adelantar</div>
        <v-text-field
          v-model.number="montoAdelantoInput"
          label="Monto"
          prefix="$"
          outlined
          dense
          type="number"
        />
        <v-btn block color="black" class="white--text mt-4" @click="confirmarAdelanto">Confirmar</v-btn>
      </v-card>
    </v-dialog>

    <!-- DIALOG: Liquidar -->
    <v-dialog v-model="dialogLiquidar" max-width="500px">
      <v-card class="pa-6" style="border-radius: 20px;">
        <div class="text-h6 font-weight-bold mb-4">Método de liquidación</div>
        <v-autocomplete
          v-model="metodoLiquidacion"
          :items="['Fresher Account', 'Otro']"
          label="Método"
          outlined
          dense
        />

        <v-menu
          v-if="metodoLiquidacion === 'Otro'"
          ref="menuFecha"
          v-model="menuFecha"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaDeposito"
              label="Fecha de depósito"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker v-model="fechaDeposito" @input="menuFecha = false" />
        </v-menu>

        <v-btn
          block
          color="black"
          class="white--text mt-4"
          :disabled="!puedeLiquidar"
          @click="confirmarLiquidacion"
        >
          Liquidar factura
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      factura: {
        id: 101,
        cliente: 'Cliente A',
        estado: 'CARGADA',
        fechaCarga: '2025-06-01',
        fechaAdelanto: null,
        fechaLiquidacion: null,
        montoOriginal: 100000,
        montoAdelantado: 0,
        montoFinal: 0,
        diferencia: 0,
        deudaPendiente: 0
      },
      dialogAprobar: false,
      dialogAdelantar: false,
      dialogLiquidar: false,
      montoAdelantoInput: null,
      metodoLiquidacion: null,
      fechaDeposito: null,
      menuFecha: false
    };
  },
  computed: {
    etiquetaEstado() {
      switch (this.factura.estado) {
        case 'CARGADA': return 'Cargada';
        case 'APROBADA': return 'Aprobada';
        case 'MONTO_CONFIRMADO': return 'Monto confirmado';
        case 'LIQUIDADA': return 'Liquidada';
        case 'LIQUIDADA_CON_DEUDA': return 'Liquidada con deuda';
        default: return this.factura.estado;
      }
    },
    estadoColor() {
      switch (this.factura.estado) {
        case 'CARGADA': return 'grey';
        case 'APROBADA': return 'blue darken-2';
        case 'MONTO_CONFIRMADO': return 'orange darken-2';
        case 'LIQUIDADA': return 'green';
        case 'LIQUIDADA_CON_DEUDA': return 'red darken-1';
        default: return 'grey';
      }
    },
    puedeLiquidar() {
      return this.metodoLiquidacion === 'Fresher Account' || (this.metodoLiquidacion === 'Otro' && this.fechaDeposito);
    }
  },
  methods: {
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDateToday() {
      return moment().format('YYYY-MM-DD');
    },
    aprobarFactura() {
      this.factura.estado = 'APROBADA';
      this.factura.fechaAprobacion = this.formatDateToday();
      this.dialogAprobar = false;
    },
    confirmarAdelanto() {
      this.factura.estado = 'MONTO_CONFIRMADO';
      this.factura.montoAdelantado = this.montoAdelantoInput;
      this.factura.fechaAdelanto = this.formatDateToday();
      this.dialogAdelantar = false;
      this.montoAdelantoInput = null;
    },
    confirmarLiquidacion() {
      const fecha = this.metodoLiquidacion === 'Fresher Account'
        ? this.formatDateToday()
        : this.fechaDeposito;

      this.factura.fechaLiquidacion = fecha;
      this.factura.montoFinal = this.factura.montoOriginal;
      this.factura.diferencia = this.factura.montoFinal - this.factura.montoAdelantado;
      this.factura.deudaPendiente = Math.max(0, this.factura.diferencia < 0 ? -this.factura.diferencia : 0);
      this.factura.estado = this.factura.deudaPendiente > 0 ? 'LIQUIDADA_CON_DEUDA' : 'LIQUIDADA';

      // Reset
      this.dialogLiquidar = false;
      this.metodoLiquidacion = null;
      this.fechaDeposito = null;
    }
  }
};
</script>
